<template>
    <div class="px-4 py-8 sm:px-10">
        <NftLogo :nft="nft"></NftLogo>

        <h2 class="text-lg leading-6 font-medium text-gray-900">{{ translate('stripeWait.body:headline') }}</h2>
            <div>
                <p class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2 mb-4">{{ translate('stripeWait.body:subline') }}</p>

                <div class="mt-1 sm:mt-0 sm:col-span-2">
                    <div class="flex justify-center px-6 pt-6 pb-6 border-2 border-gray-300 border-dashed border-blue-500 rounded-md">
                        <div class="space-y-1 text-center">
                            <svg class="mx-auto h-12 w-12 text-blue-500"  version="1.1" id="L4" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                 viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve">
                                <circle fill="#000" stroke="none" cx="6" cy="50" r="6">
                                    <animate
                                        attributeName="opacity"
                                        dur="1s"
                                        values="0;1;0"
                                        repeatCount="indefinite"
                                        begin="0.1"/>
                                </circle>
                                <circle fill="#000" stroke="none" cx="26" cy="50" r="6">
                                    <animate
                                        attributeName="opacity"
                                        dur="1s"
                                        values="0;1;0"
                                        repeatCount="indefinite"
                                        begin="0.2"/>
                                </circle>
                                <circle fill="#000" stroke="none" cx="46" cy="50" r="6">
                                    <animate
                                        attributeName="opacity"
                                        dur="1s"
                                        values="0;1;0"
                                        repeatCount="indefinite"
                                        begin="0.3"/>
                                </circle>
                            </svg>
                            <div class="text-sm text-gray-600 text-center">
                                <span class="text-blue-600 font-medium">{{ translate('stripeWait.body:wait') }}</span>
                            </div>
                            <p class="text-xs text-gray-500"></p>
                        </div>
                    </div>
                </div>
            </div>
    </div>

</template>

<style>

</style>

<script>

import NftLogo from "./Common/NftLogo";
import translate from "../../lang";
import {usePage} from "@inertiajs/inertia-vue3";
export default {
    components: {
        NftLogo
    },
    props: {
        nft: Object,
    },
    setup() {
        return {
            translate: translate('upload-' + usePage().props.value.metaDataType.type)
        }
    }
};
</script>
